module.exports = __webpack_public_path__ + "media/fresh/grants-7474486a.svg";